import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Option,
  Select,
  Typography
} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import DateField from "../dateField";
import Dict from "../../../helper/dict";
import {FromToTimeClock} from "../fromToTimeClock/timeClock";

export function CalendarForm({event, open, setOpen, onSave, setLastDataRefresh}) {
  const handleOpen = () => setOpen(!open);

  const [id, setId] = useState(null);
  const [title, setTitle] = useState("تایم آزاد");
  const [jalaliDate, setJalaliDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [weekDayId, setWeekDayId] = useState(0);
  const [from, setFrom] = useState("00:00");
  const [to, setTo] = useState("00:00");

  useEffect(() => {
    setId(event?.events?.[0]?.id || event.id || null);
    setTitle(event?.events?.[0]?.title || event.title || null);
    setJalaliDate(event?.date ?? "");
    setStartDate(event?.events?.[0]?.start_date ?? event.jalaliDate);
    setEndDate(event?.events?.[0]?.end_date ?? event.jalaliDate);
    setWeekDayId(event?.events?.[0]?.week_day_id || event.week_day_id || null);
    setFrom(event?.events?.[0]?.from || event.from || "00:00");
    setTo(event?.events?.[0]?.to || event.to || "00:00");
  }, [event]);

  const save = () => {
    onSave(id, "تایم آزاد", from, to, startDate, endDate, weekDayId);
    handleOpen()
  };

  return (
    <>
      <Dialog className="max-h-screen overflow-y-scroll md:h-fit" open={open} handler={handleOpen}
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>ویرایش/جدید</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col">

          <div className="grid grid-cols-2 gap-x-2">
            <div className="mb-4 w-1/2">
              <DateField
                className="my-4 w-full"
                date={startDate}
                setDate={setStartDate}
                label="از تاریخ"
              />
            </div>

            <div className="mb-4 w-1/2 px-4 mr-2">
              <DateField
                className="my-4 mx-4 w-full"
                date={endDate}
                setDate={setEndDate}
                label="تا تاریخ"
              />
            </div>
          </div>

          <Select variant="static" className="rtl" dir="rtl"
                  label={Dict('one_week_day')}
                  value={String(weekDayId)}
                  onChange={(val) => setWeekDayId(parseInt(val))}>
            <Option value="1">شنبه</Option>
            <Option value="2">یکشنبه</Option>
            <Option value="3">دوشنبه</Option>
            <Option value="4">سه‌شنبه</Option>
            <Option value="5">چهارشنبه</Option>
            <Option value="6">پنجشنبه</Option>
            <Option value="7">جمعه</Option>
          </Select>

          <div className="flex flex-col md:flex-row w-full">
            <FromToTimeClock
              from_label="از ساعت:"
              to_label="تا ساعت:"
              from_value={from}
              to_value={to}
              onChangeFrom={setFrom}
              onChangeTo={setTo}
            />
          </div>

        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="text" color="gray" onClick={handleOpen} className="ml-1">
            <span>انصراف</span>
          </Button>
          <Button variant="gradient" color="gray" onClick={save}>
            <span>ذخیره</span>
          </Button>

        </DialogFooter>
      </Dialog>
    </>
  );
}